import { Spinner } from '@kollektive/design-system';
import styles from './TenantLoading.module.css';

export function TenantLoading() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Spinner size="lg" />
        <p className={styles.text}>Loading workspace...</p>
      </div>
    </div>
  );
}
